<template>
  <v-layout row wrap>
    <v-flex xs12 md6 :class="{ 'pr-3': $vuetify.breakpoint.mdAndUp }">
      <nx-form-file-image-selector
        :name="desktopImageName"
        label="Desktop multimedia (image/mp4)"
        :manual-hint-text="manualFileHint"
        :before-upload-clippings-config="['source-aspect-ratio']"
        :filters="filters"
        :value="desktopImageValue"
        :validation="required ? 'required' : null"
        @input="handleDesktopInput"
      />
    </v-flex>
    <v-flex xs12 md6 :class="{ 'pl-3': $vuetify.breakpoint.mdAndUp }">
      <nx-form-file-image-selector
        :name="mobileImageName"
        label="Mobile multimedia (image/mp4)"
        :manual-hint-text="manualFileHint"
        :before-upload-clippings-config="['source-aspect-ratio']"
        :filters="filters"
        :value="mobileImageValue"
        :validation="required ? 'required' : null"
        @input="handleMobileInput"
      />
    </v-flex>
    <v-flex xs12>
      <nx-form-text
        :name="imageAltName"
        :label="$t('message.form.fields.imageAlt')"
        :value="imageAltValue"
        :hint="$t('message.form.fields.imageAltHint')"
        :validation="altRequired ? 'required' : null"
        @input="handleImageAltInput"
        persistent-hint
      />
    </v-flex>
  </v-layout>
</template>

<script>
import NxFormFileImageSelector from '@/modules/file/form/FileImageSelector';
import isEmpty from 'lodash/isEmpty';
import NxFormText from '@/modules/form/components/FormText';
import { mapGetters } from 'vuex';

export default {
  name: 'nx-scrollytelling-slide-editor-form-image-field',
  inject: ['$parentForm'],
  components: {
    NxFormText,
    NxFormFileImageSelector,
  },
  props: {
    desktopImageName: {
      type: String,
      required: true,
    },
    mobileImageName: {
      type: String,
      required: true,
    },
    imageAltName: {
      type: String,
      required: true,
    },
    desktopImageValue: {
      type: [Number, Object],
    },
    mobileImageValue: {
      type: [Number, Object],
    },
    imageAltValue: {
      type: String,
    },
    required: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters('scrollytelling', [
      'collectionId',
    ]),
    filters() {
      return {
        // TODO: configure a collectionId
        mimeType: 'video/mp4, image/*',
        collectionId: this.collectionId,
      };
    },
    altRequired() {
      if (this.desktopImageValue || this.mobileImageValue) {
        return true;
      }

      return false;
    },
    manualFileHint() {
      return `${this.$t('message.upload.scrollytellingSelectFile')}`;
    },
  },
  methods: {
    handleImageAltInput(value) {
      this.$parentForm.updateField(this.imageAltName, value);
    },
    handleDesktopInput(value, valueAsObject) {
      if (valueAsObject === undefined) {
        this.$parentForm.updateField(this.mobileImageName, valueAsObject);
      }
      if (isEmpty(this.mobileImageValue)) {
        this.$parentForm.updateField(this.mobileImageName, valueAsObject);
      }
      this.$parentForm.updateField(this.desktopImageName, valueAsObject);

      if (!this.imageAltValue) {
        if (this.$parentForm.draft.multimediaDesktopImage) {
          this.$parentForm.updateField('multimediaImageAlt', this.$parentForm.draft.multimediaDesktopImage.name);
        }
        if (this.$parentForm.draft.multimediaMobileImage) {
          this.$parentForm.updateField('multimediaImageAlt', this.$parentForm.draft.multimediaMobileImage.name);
        }
      }

      this.$emit('selection', value);
    },
    handleMobileInput(value, valueAsObject) {
      if (valueAsObject === undefined) {
        this.$parentForm.updateField(this.desktopImageName, valueAsObject);
      }
      if (isEmpty(this.desktopImageValue)) {
        this.$parentForm.updateField(this.desktopImageName, valueAsObject);
      }
      this.$parentForm.updateField(this.mobileImageName, valueAsObject);

      if (!this.imageAltValue) {
        if (this.$parentForm.draft.multimediaDesktopImage) {
          this.$parentForm.updateField('multimediaImageAlt', this.$parentForm.draft.multimediaDesktopImage.name);
        }
        if (this.$parentForm.draft.multimediaMobileImage) {
          this.$parentForm.updateField('multimediaImageAlt', this.$parentForm.draft.multimediaMobileImage.name);
        }
      }

      this.$emit('selection', value);
    },
  },
  mounted() {
    this.$parentForm.$validator.validateAll();
  },
};
</script>

<style scoped>

</style>
